import { Routes } from '@xolv-mybrightlink/common';

export const fixHyperlinkOnClickHandler = (
  articleContentDocument: Document,
) => {
  if (__JS_ENV_VARS__['JS_ENV_CMS_GRAPHQL_URL']) {
    const wpBaseUrl = __JS_ENV_VARS__['JS_ENV_CMS_GRAPHQL_URL'].replaceAll(
      '/wp-json',
      '',
    );
    const lmsBaseUrl = __JS_ENV_VARS__['JS_ENV_LMS_BASE_URL'];
    articleContentDocument.querySelectorAll('a').forEach((link) => {
      link.style.textDecoration = 'none';
      link.target = '_top';
      if (
        !link.href.startsWith(wpBaseUrl + '/wp-content') &&
        (link.href.startsWith(wpBaseUrl + '/?p=') ||
          link.href.startsWith(wpBaseUrl + '/'))
      ) {
        let pathname = '';
        if (link.href.startsWith(wpBaseUrl + '/')) {
          pathname = new URL(link.href).pathname;
        } else if (link.href.startsWith(wpBaseUrl + '/?p=')) {
          pathname = link.href.replaceAll(wpBaseUrl + '/?p=', '/');
        }
        link.href = `${Routes.resources.articles.index}${pathname}`;
      } else if (link.href.startsWith('/wp-content')) {
        link.href = lmsBaseUrl + link.href;
      }
    });
  }
  return articleContentDocument.documentElement.innerHTML;
};
